import React, { Suspense } from 'react'

import { useTranslation } from 'react-i18next'
import { Await, useLoaderData, useNavigation } from 'react-router-dom'

import LoadingMessage from '@components/LoadingMessage'
import MyScoresView from '@components/myScores/MyScoresView'
import LoadingSpinner from '@components/shared/LoadingSpinner'
import { usePageTitle } from '@providers/LayoutProvider'

import { MyScoresLoaderResponse } from './loaders/myScores.loader'

const MyScoresPage: React.FC = () => {
  const { t } = useTranslation()
  const data = useLoaderData() as MyScoresLoaderResponse
  const navigation = useNavigation()

  usePageTitle(t('titles.myScores'))

  const isReloading =
    navigation.state === 'loading' &&
    navigation.formData != null &&
    ['/home', '/home/myScores'].includes(navigation.location.pathname)

  return (
    <>
      {isReloading && <LoadingMessage />}
      <Suspense
        fallback={
          <>
            {/* Spacer */}
            <div className="h-16 w-full" />

            <LoadingSpinner />
          </>
        }>
        <Await resolve={data.privateScores}>
          {(privateScoresResp) => (
            <MyScoresView
              initialData={privateScoresResp}
              order={data.order}
              filters={data.filters}
            />
          )}
        </Await>
      </Suspense>
    </>
  )
}

export default MyScoresPage
